import React from 'react';
import { Trophy, Calendar } from 'lucide-react';

interface ContestEndedBannerProps {
  endedAt?: Date;
}

export default function ContestEndedBanner({ endedAt }: ContestEndedBannerProps) {
  return (
    <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6">
      <div className="flex items-start">
        <Trophy className="h-6 w-6 text-red-500 mr-3 flex-shrink-0 mt-0.5" />
        <div>
          <h3 className="text-lg font-medium text-red-800">
            El concurso ha finalizado
          </h3>
          <p className="mt-1 text-sm text-red-700">
            La votación está cerrada. ¡Gracias a todos por participar!
          </p>
          {endedAt && (
            <div className="flex items-center mt-2 text-xs text-red-600">
              <Calendar className="h-4 w-4 mr-1" />
              Finalizado el {endedAt.toLocaleDateString('es', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}